import { BookOpenUser, Link } from "@phosphor-icons/react";
import { Button } from "../components/button";
import { Card,CardHeader ,CardTitle,CardContent, CardFooter} from "../components/card";
import { useLanguage } from "../context/language";
import devOpsIcon from "../assets/certificates-icons/devOps.svg";
import nodeJsIcon from "../assets/certificates-icons/nodeJs.svg";
import reactIcon from "../assets/certificates-icons/react.svg";
import reactNativeIcon from "../assets/certificates-icons/reactNative.svg";

export function Certifications() {
    const { language } = useLanguage();

    return(
        <>
            <h1 className="text-white text-5xl text-center pt-10 mobile:text-4xl">
                {language === "pt" ? "Certificados" : "Certificates"}
            </h1>
            <div className="p-10 flex gap-5 flex-wrap justify-center">
                <Card className="w-72 h-[22rem] transition-all duration-300 hover:scale-105 hover:shadow-xl hover:-translate-y-1 cursor-pointer">
                    <CardHeader>
                    <CardTitle>Node.js</CardTitle>
                    </CardHeader>
                    <CardContent className="flex justify-center">
                        <div className="flex-row items-center space-x-2">
                            <img
                                className="w-40 h-40"
                                src={nodeJsIcon}
                                alt="icon nodejs"
                            />
                            <div className="flex space-x-4 items-center mt-4 justify-center">
                                <BookOpenUser />
                                <p>{language === "pt" ? "Formação" : "Education"}</p>
                            </div>
                        </div>
                    </CardContent>
                    <CardFooter className="flex justify-center gap-2">
                    <Button className="p-0 bg-transparent hover:bg-transparent border-0">
                        <a
                        rel="noreferrer"
                        href="https://app.rocketseat.com.br/certificates/69a6d630-9565-4978-bba6-f75502f2241b"
                        target="_blank"
                        className="flex items-center justify-center gap-2 px-6 py-2.5 bg-[#383b4d] hover:bg-[#2d2f3d] border border-[#a7a8b0] hover:border-vermelhoPrincipal text-white font-medium rounded-lg transition-all duration-300 hover:shadow-lg hover:scale-105"
                        >
                        <Link size={18} />
                            {language === "pt" ? "Ver Certificado" : "View Certificate"}
                        </a>
                    </Button>
                    </CardFooter>
                </Card>
                <Card className="w-72 h-[22rem] transition-all duration-300 hover:scale-105 hover:shadow-xl hover:-translate-y-1 cursor-pointer">
                    <CardHeader>
                        <CardTitle>React</CardTitle>
                    </CardHeader>
                    <CardContent className="flex justify-center">
                        <div className="flex-row items-center space-x-2">
                            <img
                                className="w-40 h-40"
                                src={reactIcon}
                                alt="icon react"
                            />
                            <div className="flex space-x-4 items-center mt-4 justify-center">
                                <BookOpenUser />
                                <p>{language === "pt" ? "Formação" : "Education"}</p>
                            </div>
                        </div>
                    </CardContent>
                    <CardFooter className="flex justify-center gap-2">
                    <Button className="p-0 bg-transparent hover:bg-transparent border-0">
                        <a
                            rel="noreferrer"
                            href="https://app.rocketseat.com.br/certificates/1e6c293e-467d-4242-bb00-ea7cf533451f"
                            target="_blank"
                            className="flex items-center justify-center gap-2 px-6 py-2.5 bg-[#383b4d] hover:bg-[#2d2f3d] border border-[#a7a8b0] hover:border-vermelhoPrincipal text-white font-medium rounded-lg transition-all duration-300 hover:shadow-lg hover:scale-105"
                        >
                            <Link size={18} />
                            {language === "pt" ? "Ver Certificado" : "View Certificate"}
                        </a>
                    </Button>
                    </CardFooter>
                </Card>
                <Card className="w-72 h-[22rem] transition-all duration-300 hover:scale-105 hover:shadow-xl hover:-translate-y-1 cursor-pointer">
                    <CardHeader>
                        <CardTitle>React Native</CardTitle>
                    </CardHeader>
                    <CardContent className="flex justify-center">
                        <div className="flex-row items-center space-x-2">
                            <img
                                className="w-40 h-40"
                                src={reactNativeIcon}
                                alt="icon react native"
                            />
                            <div className="flex space-x-4 items-center mt-4 justify-center">
                                <BookOpenUser />
                                <p>{language === "pt" ? "Formação" : "Education"}</p>
                            </div>
                        </div>
                    </CardContent>
                    <CardFooter className="flex justify-center gap-2">
                    <Button className="p-0 bg-transparent hover:bg-transparent border-0">
                        <a
                            rel="noreferrer"
                            href="https://app.rocketseat.com.br/certificates/46543431-b2fd-44ca-8302-80f545439867"
                            target="_blank"
                            className="flex items-center justify-center gap-2 px-6 py-2.5 bg-[#383b4d] hover:bg-[#2d2f3d] border border-[#a7a8b0] hover:border-vermelhoPrincipal text-white font-medium rounded-lg transition-all duration-300 hover:shadow-lg hover:scale-105"
                        >
                            <Link size={18} />
                            {language === "pt" ? "Ver Certificado" : "View Certificate"}
                        </a>
                    </Button>
                    </CardFooter>
                </Card>
                <Card className="w-72 h-[22rem] transition-all duration-300 hover:scale-105 hover:shadow-xl hover:-translate-y-1 cursor-pointer">
                    <CardHeader>
                        <CardTitle>DevOps</CardTitle>
                    </CardHeader>
                    <CardContent className="flex justify-center">
                        <div className="flex-row items-center space-x-2">
                            <img
                                className="w-40 h-40"
                                src={devOpsIcon}
                                alt="icon devops"
                            />
                            <div className="flex space-x-4 items-center mt-4 justify-center">
                                <BookOpenUser />
                                <p>{language === "pt" ? "Formação" : "Education"}</p>
                            </div>
                        </div>
                    </CardContent>
                    <CardFooter className="flex justify-center gap-2">
                    <Button className="p-0 bg-transparent hover:bg-transparent border-0">
                        <a
                            rel="noreferrer"
                            href="https://app.rocketseat.com.br/certificates/f5982883-f2d9-4401-a0ff-852146d6a788"
                            target="_blank"
                            className="flex items-center justify-center gap-2 px-6 py-2.5 bg-[#383b4d] hover:bg-[#2d2f3d] border border-[#a7a8b0] hover:border-vermelhoPrincipal text-white font-medium rounded-lg transition-all duration-300 hover:shadow-lg hover:scale-105"
                        >
                            <Link size={18} />
                            {language === "pt" ? "Ver Certificado" : "View Certificate"}
                        </a>
                    </Button>
                    </CardFooter>
                </Card>
            </div>
        </>
    )
}